import { useAccessToken } from "hooks/useAccessToken";
import useAlert from "hooks/useAlert";
import { useMutation, useQueryClient } from "react-query";

import { customerAccountQueryKey } from "ApiLayer/AccountManagement/queryCustomerAccount";
import { userQueryKey } from "hooks/useUser";

import mutationUpdateCustomerAccountFn from "ApiLayer/AccountManagement/updateCustomerAccount";

export const useUpdateCustomerAccount = (customerAccountUid: string) => {
    const accessToken = useAccessToken();
    const alert = useAlert();
    const queryClient = useQueryClient();

    return useMutation({
        onError: (error) => {
            if (typeof error === "string") {
                alert.error(error);
            } else {
                alert.error(`${error}`);
            }
        },
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: userQueryKey });
            queryClient.invalidateQueries({
                queryKey: customerAccountQueryKey,
            });
            alert.success("Organization updated.");
        },
        mutationFn: async (customerAccount: CustomerAccount) =>
            mutationUpdateCustomerAccountFn(accessToken, customerAccountUid, customerAccount),
    });
};
